import { formatDate } from './date-time';

/** MySQL / legacy "never set" sentinel — must not match ISO microseconds (…000000Z). */
export function isMysqlZeroDateString(str: string): boolean {
  return str.trim().startsWith('0000-00-00');
}

/**
 * Parses admin/API user datetime fields for table display.
 * Returns null for empty values, MySQL zero dates, and unparseable strings.
 */
export function tryParseUserDateValue(value: unknown): Date | null {
  if (value == null || value === '') {
    return null;
  }
  const str = String(value).trim();
  if (!str || isMysqlZeroDateString(str)) {
    return null;
  }
  const d = new Date(str);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Short table cell label (dd.MM.yy) or "-" when unset / invalid. */
export function formatUserTableShortDate(value: unknown): string {
  const d = tryParseUserDateValue(value);
  return d ? formatDate(d, 'dd.MM.yy') : '-';
}
